<template>
    <section class="col-12 px-0 h-100">
        <div class="container mw-100 d-lg-none">
            <div class="row py-1">
                <div class="col-12 text-center">
                    <img alt="" height="50" :src="iconEqual">
                </div>
            </div>
        </div>
        <div class="d-lg-none">
            <div class="container mw-100 div-img border-gray bg-dark recommended-recap-total-tile mb-0 py-1">
                <div class="row py-1">
                    <div class="col-12 text-center text-white">
                        <p class="mx-auto mb-0 h4">
                            <strong>{{ offersTotalPriceLabel }}</strong>
                        </p>
                    </div>
                    <!--/* PRIX SUR DEVICE MOBILE */-->
                    <div class="col-12 text-center">
                        <ob1-prix
                            :custom="'text-primary'"
                            :duration="totalPrice.duration"
                            :initial-price="totalPrice.initialPrice"
                            :is-compact="totalPrice.compact"
                            :is-inverse="totalPrice.inverse"
                            :price="totalPrice.price"
                            :price-details="totalPrice.priceDetails"
                            :show-by-month="totalPrice.showByMonth"
                            :show-end-of-promotion-price="totalPrice.showEndOfPromotionPrice"
                            :show-from="totalPrice.showFrom"
                            :show-promo-duration="totalPrice.showPromoDuration"
                        />
                    </div>

                    <!--/* PROMO REMISE OPEN SUR LE FORFAIT MOBILE SUR FORMAT MOBILE*/-->
                    <div
                        v-if="mobileOffer.discountLabelWithMobileOfferMention"
                        class="col-12 d-flex align-items-center justify-content-center"
                    >
                        <div class="my-1" style="width: fit-content;">
                            <hr class="separator separator--gray4">
                            <div class="my-1 d-flex align-items-center justify-content-center">
                                <span
                                    class="alert-icon icon-phone-fund-euro text-primary font-size-28 me-1"
                                    aria-hidden="true"
                                />
                                <span class="ob1-alert-title fw-bold text-white">{{ formattedMobileDiscountLabel }}</span>
                            </div>
                            <hr class="separator separator--gray4">
                        </div>
                    </div>

                    <div class="col-12 text-center">
                        <generic-button-cta
                            :dto-from-object="genericButtonCta"
                            css-classes="btn-primary btn-inverse"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="d-none d-lg-block h-100">
            <div class="container mw-100 div-img d-flex align-content-center flex-wrap border-gray bg-dark h-100 recommended-recap-total-tile mb-0">
                <div class="row py-1">
                    <div class="col-12 text-center text-white">
                        <h3 class="mb-0 h4">
                            <strong>{{ offersTotalPriceLabel }}</strong>
                        </h3>
                    </div>
                    <!--/* PRIX SUR DESKTOP */-->
                    <div class="col-12 text-center">
                        <ob1-prix
                            :custom="'text-primary'"
                            :duration="totalPrice.duration"
                            :initial-price="totalPrice.initialPrice"
                            :is-compact="totalPrice.compact"
                            :is-inverse="totalPrice.inverse"
                            :price="totalPrice.price"
                            :price-details="totalPrice.priceDetails"
                            :show-by-month="totalPrice.showByMonth"
                            :show-end-of-promotion-price="totalPrice.showEndOfPromotionPrice"
                            :show-from="totalPrice.showFrom"
                            :show-promo-duration="totalPrice.showPromoDuration"
                        />
                    </div>

                    <!--/* PROMO REMISE OPEN SUR LE FORFAIT MOBILE SUR DESKTOP*/-->
                    <div
                        v-if="mobileOffer.discountLabelWithMobileOfferMention"
                        class="col-12 d-flex align-items-center justify-content-center"
                    >
                        <div class="my-1" style="width: fit-content;">
                            <hr class="separator separator--gray4">
                            <div class="my-1 d-flex align-items-center justify-content-center">
                                <span
                                    class="alert-icon icon-phone-fund-euro text-primary font-size-28 me-1"
                                    aria-hidden="true"
                                />
                                <span class="ob1-alert-title fw-bold text-white">{{ formattedMobileDiscountLabel }}</span>
                            </div>
                            <hr class="separator separator--gray4">
                        </div>
                    </div>

                    <div class="col-12 text-center">
                        <generic-button-cta
                            :dto-from-object="genericButtonCta"
                            css-classes="btn-primary btn-inverse"
                        />
                    </div>
                </div>
            </div>
        </div>
        <img alt="" class="picto-equal d-none d-lg-block" :src="iconEqual">
    </section>
</template>

<script>

import GenericButtonCta from "../../../../../../common/broadband/components/GenericButtonCta.vue";

export default {
    name: "RecommendedOfferRecapTile",
    components: {
        GenericButtonCta
    },
    props: {
        eligibilityResult: {type: Object, required: false},
        iconEqual: {type: String, required: true},
        internetOffer: {type: Object, required: true},
        mobileOffer: {type: Object, required: true},
        offersTotalPriceLabel: {type: String, required: true},
        genericButtonCta: {type: Object, required: true},
        totalPrice: {type: Object, required: true}
    },
    computed: {
        formattedMobileDiscountLabel() {
            if (this.mobileOffer.discountLabelWithMobileOfferMention) {
                return this.handleBreakingSpaces(this.mobileOffer.discountLabelWithMobileOfferMention)
            } else {
                return undefined
            }
        }
    },
    methods: {
        handleBreakingSpaces(str) {
            return str.replace('&nbsp;', '\xa0');
        }
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_variables', 'ob1_common';

.border-gray {
    border: px-to-rem(2) solid $gray-lighter;
}

.picto-equal {
    position: relative;
    top: -55%;
    left: -40px;
    height: 50px;
    z-index: 200;
}

.div-img {
    position: relative;
}
</style>
